import React from "react";
import TeaserGrid from "../../organisms/TeaserGrid";
export function BlockSolution(props) {
    return /*#__PURE__*/ React.createElement(TeaserGrid, {
        gridHeading: props.gridHeading,
        teasers: props.teasers
    });
}
